import Button from "@mui/material/Button";
import { styled } from '@mui/material/styles';
import { Colors } from "../Assets/Config/color.config";

// 加入 shouldForwardProp 避免 customTheme 被傳到原生 HTML DOM 上報錯
const NavButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "customTheme" 
})(({ customTheme }) => ({
    textTransform: 'none',
    fontSize: '1.2rem',
    // 使用 customTheme 來讀取你的顏色設定，並加上可選串連 (?.) 保護機制
    color: customTheme ? Colors[customTheme]?.primaryColor : 'inherit',
    backgroundColor: "transparent",
    '&:hover': {
      backgroundColor: customTheme ? Colors[customTheme]?.secondBackground : 'transparent',
    },
}));

export default NavButton;